import ResultItem from './ResultItem';
export { ResultItem };
export default ResultItem;
